export const BEACON_TIMEOUT_SECONDS = 5;
export const BEACON_INTERVAL_SECONDS_MAX = 60;
export const BEACON_INTERVAL_SECONDS_MIN = 30;
